/* global axios */

import ApiClient from './ApiClient';

// Catálogos de produtos da Meta por caixa WhatsApp Cloud. `list` lê apenas o
// registro local; as demais chamadas falam com a Meta e só partem de ações
// explícitas do usuário.
class WhatsappCatalogsAPI extends ApiClient {
  constructor() {
    super('whatsapp_catalogs', { accountScoped: true });
  }

  list(params = {}) {
    return axios.get(this.url, { params });
  }

  sync(inboxId) {
    return axios.post(`${this.url}/sync`, { inbox_id: inboxId });
  }

  createCatalog(inboxId, name) {
    return axios.post(this.url, {
      inbox_id: inboxId,
      whatsapp_catalog: { name },
    });
  }

  connect(id) {
    return axios.post(`${this.url}/${id}/connect`);
  }

  disconnect(id) {
    return axios.post(`${this.url}/${id}/disconnect`);
  }

  commerceSettings(inboxId) {
    return axios.get(`${this.url}/commerce_settings`, {
      params: { inbox_id: inboxId },
    });
  }

  updateCommerceSettings(inboxId, settings) {
    return axios.post(`${this.url}/commerce_settings`, {
      inbox_id: inboxId,
      is_catalog_visible: !!settings.is_catalog_visible,
      is_cart_enabled: !!settings.is_cart_enabled,
    });
  }

  products(id, after = '') {
    return axios.get(`${this.url}/${id}/products`, {
      params: after ? { after } : {},
    });
  }

  createProduct(id, product) {
    return axios.post(`${this.url}/${id}/products`, { product });
  }

  updateProduct(id, productId, product) {
    return axios.patch(`${this.url}/${id}/products/${productId}`, {
      product,
    });
  }

  deleteProduct(id, product) {
    return axios.delete(`${this.url}/${id}/products/${product.id}`, {
      params: { retailer_id: product.retailer_id },
    });
  }
}

export default new WhatsappCatalogsAPI();
